<template>
    <div class="bridge-log container h-100">
        <div class="header">
            <el-form class="form" label-width="80px" size="mini" inline @submit.native.prevent>
                <el-form-item label="请求路径">
                    <el-input v-model="query.path" placeholder="请输入请求路径" clearable @keyup.enter.native="searchBtn"></el-input>
                </el-form-item>
                <el-form-item label="请求方法">
                    <el-select v-model="query.method" placeholder="请选择请求方法" clearable style="width: 130px;">
                        <el-option v-for="item in methodOptions" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="请求IP">
                    <el-input v-model="query.ip" placeholder="请输入请求IP" clearable @keyup.enter.native="searchBtn"></el-input>
                </el-form-item>
                <el-form-item label="业务code">
                    <el-input v-model="query.code" placeholder="请输入业务code" clearable @keyup.enter.native="searchBtn"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" class="el-button--operation" size="mini"
                               style="margin-left:20px;" @click="searchBtn">查询
                    </el-button>
                    <el-button style="margin-right:0;" size="mini" @click="resetBtn">重置</el-button>
                </el-form-item>
            </el-form>
        </div>

        <!--    日志列表-->
        <el-row class="panel-container">
            <el-col :span="24">
                <div class="default-table mlTable-table" v-loading="loading">
                    <el-table :data="list" border :row-class-name="rowClassName">
                        <el-table-column label="序号" type="index" align="center" width="55">
                            <template slot-scope="{$index}">
                                {{ offset + $index + 1 }}
                            </template>
                        </el-table-column>
                        <el-table-column label="请求路径" prop="path" align="left" min-width="220" show-overflow-tooltip></el-table-column>
                        <el-table-column label="请求方法" align="center" width="90">
                            <template slot-scope="scope">
                                <el-tag :type="methodTagType(scope.row.method)" size="mini">{{ scope.row.method || '-' }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="请求IP" prop="ip" align="center" width="140"></el-table-column>
                        <el-table-column label="HTTP状态码" align="center" width="110">
                            <template slot-scope="scope">
                                <el-tag :type="httpTagType(scope.row.http_code)" size="mini">{{ scope.row.http_code || '-' }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="业务code" prop="code" align="center" width="110">
                            <template slot-scope="scope">
                                <span>{{ scope.row.code || '-' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="耗时(ms)" prop="cost_time" align="center" width="100">
                            <template slot-scope="scope">
                                {{ scope.row.cost_time != null ? scope.row.cost_time : '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="请求时间" prop="created_at" align="center" width="170"></el-table-column>
                        <el-table-column label="操作" align="center" width="130">
                            <template slot-scope="scope">
                                <el-link type="primary" icon="el-icon-view" :underline="false" @click="viewDetail(scope.row)">详情</el-link>
                                <el-link type="danger" icon="el-icon-delete" :underline="false" style="margin-left:12px;"
                                         @click="deleteRow(scope.row)">删除
                                </el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="mlTable-page">
                        <div class="mlTable-do">
                            <el-tooltip class="item" effect="dark" content="刷新表格" placement="top">
                                <el-button @click="refreshBtn" icon="el-icon-refresh" circle
                                           style="margin-left:1px;margin-top: 10px"></el-button>
                            </el-tooltip>
                        </div>
                        <div class="mlTable-pagination">
                            <Pagination
                                    v-show="total>0"
                                    :total="total"
                                    :page.sync="params.current_page"
                                    :limit.sync="params.page_size"
                                    @pagination="handleQuery"
                            />
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>

        <!--    请求详情抽屉-->
        <el-drawer
                title="桥接请求日志详情"
                :visible.sync="drawerVisible"
                :modal="false"
                size="50%"
                append-to-body
        >
            <div class="detail-wrap" v-loading="detailLoading">
                <el-form label-width="120px" size="small" class="detail-form">
                    <el-form-item label="ID：">
                        <span>{{ detail.id }}</span>
                    </el-form-item>
                    <el-form-item label="请求路径：">
                        <span>{{ detail.path }}</span>
                    </el-form-item>
                    <el-form-item label="请求方法：">
                        <span>{{ detail.method }}</span>
                    </el-form-item>
                    <el-form-item label="请求IP：">
                        <span>{{ detail.ip }}</span>
                    </el-form-item>
                    <el-form-item label="HTTP状态码：">
                        <span>{{ detail.http_code }}</span>
                    </el-form-item>
                    <el-form-item label="业务code：">
                        <span>{{ detail.code }}</span>
                    </el-form-item>
                    <el-form-item label="耗时(ms)：">
                        <span>{{ detail.cost_time }}</span>
                    </el-form-item>
                    <el-form-item label="请求时间：">
                        <span>{{ detail.created_at }}</span>
                    </el-form-item>
                    <el-form-item label="请求参数：">
                        <pre class="json-block">{{ prettyJson(detail.input) }}</pre>
                    </el-form-item>
                    <el-form-item label="响应内容：">
                        <pre class="json-block">{{ prettyJson(detail.response) }}</pre>
                    </el-form-item>
                </el-form>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import {getBridgeLogList, getBridgeLogInfo, deleteBridgeLog} from '@/api/bridgeLog'

export default {
    name: 'bridgeLog',
    data() {
        return {
            // 查询条件
            query: {
                path: '',
                method: '',
                ip: '',
                code: ''
            },
            methodOptions: ['GET', 'POST', 'PUT', 'PATCH', 'DELETE', 'OPTIONS', 'HEAD'],
            // 列表数据
            list: [],
            params: {
                current_page: 1,
                page_size: 15,
            },
            total: 0,
            loading: false,
            // 详情
            drawerVisible: false,
            detailLoading: false,
            detail: {}
        }
    },
    computed: {
        offset() {
            return (this.params.current_page - 1) * this.params.page_size
        }
    },
    methods: {
        // 获取桥接请求日志列表
        async getList(data) {
            this.loading = true
            try {
                const res = await getBridgeLogList(data)
                const model = res.model || {}
                this.list = model.list || []
                const page = model.page || {}
                this.total = page.total || 0
            } finally {
                this.loading = false
            }
        },
        // 详情
        viewDetail(row) {
            this.drawerVisible = true
            this.detailLoading = true
            this.detail = {...row}
            getBridgeLogInfo({id: row.id}).then(res => {
                this.detail = res.model || {...row}
            }).finally(() => {
                this.detailLoading = false
            })
        },
        // 删除
        deleteRow(row) {
            this.$confirm(`确定要删除请求路径为【${row.path}】的日志吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                return deleteBridgeLog({id: row.id})
            }).then(res => {
                if (res && res.success === false) {
                    this.$message.error(res.message || '删除失败')
                    return
                }
                this.$message.success('删除成功')
                this.getList({...this.query, ...this.params})
            }).catch(() => {
            })
        },
        // 刷新
        refreshBtn() {
            this.params.current_page = 1
            this.getList({...this.query, ...this.params})
        },
        // 查询
        searchBtn() {
            this.params.current_page = 1
            this.handleQuery()
        },
        // 重置查询条件
        resetBtn() {
            this.query = {
                path: '',
                method: '',
                ip: '',
                code: ''
            }
            this.searchBtn()
        },
        // 分页/查询统一入口
        handleQuery() {
            this.getList({...this.query, ...this.params})
        },
        // 表格行着色：非 2xx 深色提示
        rowClassName({row}) {
            const code = Number(row.http_code)
            if (code >= 400) {
                return 'bridge-log-error-row'
            }
            return ''
        },
        // 请求方法对应的 tag 颜色
        methodTagType(method) {
            const m = String(method || '').toUpperCase()
            if (m === 'GET') return 'success'
            if (m === 'POST') return 'warning'
            if (m === 'PUT' || m === 'PATCH') return 'primary'
            if (m === 'DELETE') return 'danger'
            return 'info'
        },
        // HTTP 状态码对应的 tag 颜色
        httpTagType(code) {
            const c = Number(code)
            if (c >= 200 && c < 300) return 'success'
            if (c >= 400) return 'danger'
            return 'warning'
        },
        // 格式化 JSON 展示
        prettyJson(value) {
            if (value === null || value === undefined || value === '') {
                return '-'
            }
            try {
                if (typeof value === 'string') {
                    return JSON.stringify(JSON.parse(value), null, 2)
                }
                return JSON.stringify(value, null, 2)
            } catch (e) {
                return String(value)
            }
        }
    },
    created() {
        this.getList(this.params)
    }
}
</script>

<style scoped>
.bridge-log .header {
    background: #fff;
    padding: 15px 20px 0;
}
.bridge-log .header .el-form-item {
    margin-bottom: 15px;
}
.mlTable-page {
    display: flex;
    align-items: center;
    justify-content: right;
    padding: 0 15px;
    margin-top: 5px;
}
.default-table tr.el-table__row .cell {
    height: 40px !important;
    line-height: 40px !important;
    font-weight: normal;
    font-size: 12px;
}
.detail-wrap {
    padding: 0 20px 20px;
}
.detail-wrap ::v-deep .el-form-item {
    margin-bottom: 12px;
}
.json-block {
    background: #f5f7fa;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    padding: 10px;
    margin: 0;
    max-height: 320px;
    overflow: auto;
    font-size: 12px;
    line-height: 1.6;
    white-space: pre-wrap;
    word-break: break-all;
}
.bridge-log-error-row {
    background: #fef0f0;
}
</style>
